import * as React from 'react';

import {ErrorState} from 'shells/error-state/error-state';
import {Link} from 'shells/link/link';
import {LoadingPage} from 'shells/loading-page/loading-page';
import {Modal} from 'shells/modal/modal';
import {Table} from 'shells/table/table';
import {ModalHeader} from 'shells/typography/modal-header';

import {useGetPreviousInvoices} from '../graphql/hooks';

import {getInvoiceStatusBadge} from './helpers';

import styles from './previous-invoices.module.css';

type Props = {
    onClose: () => void;
};

export function PreviousInvoicesModal(props: Props) {
    const {previousInvoices, isLoading, errorMessage} = useGetPreviousInvoices();

    const columns = React.useMemo(
        () => [
            {
                id: 'date',
                Header: 'Date',
                // @ts-expect-error
                accessor: (invoice) => invoice.date,
                hasLeftBorder: true,
                dataType: 'longTimestamp',
                width: 200,
            },
            {
                id: 'amount',
                Header: 'Amount',
                // @ts-expect-error
                accessor: (invoice) => invoice.amount,
                dataType: 'string',
                width: 150,
            },
            {
                id: 'status',
                Header: 'Status',
                // @ts-expect-error
                accessor: (invoice) => getInvoiceStatusBadge(invoice.status),
                dataType: 'statusBadge',
                width: 150,
            },
            {
                id: 'pdf',
                Header: 'PDF',
                // @ts-expect-error
                accessor: (invoice) => invoice.id,
                hasRightBorder: true,
                dataType: 'component',
                width: 150,
                Cell: ({cell}: any) => (
                    <Link
                        href={`/setup/billing/download-invoice?id=${cell.value}`}
                        variant='primary'
                        size='small'
                    >
                        Download
                    </Link>
                ),
            },
        ],
        []
    );

    return (
        <Modal isOpen={true} onClose={props.onClose}>
            <ModalHeader>Previous invoices</ModalHeader>
            <div className={styles['table-container']}>
                <Table
                    isStriped={true}
                    isResizable={false}
                    isCompact={true}
                    hasHeaderBorder={true}
                    hasHeaderCellBorders={true}
                    hasHeaderTopBorder={true}
                    hasHeaderLeftBorder={true}
                    hasBorders={true}
                    hasCellBorders={false}
                    fullWidth={true}
                    disableFilters={true}
                    // @ts-expect-error
                    columns={columns}
                    data={previousInvoices || []}
                    specialStates={[
                        {
                            shouldRender: () => Boolean(errorMessage),
                            component: <ErrorState errorMessage={errorMessage} />,
                        },
                        {
                            shouldRender: () => isLoading,
                            component: <LoadingPage />,
                        },
                    ]}
                />
            </div>
        </Modal>
    );
}
